export const I18N = {
  defaultLocale: "en-GB",
  enabledLocales: ["en-GB", "en-US", "it-IT", "fr-FR", "nl-NL", "pl-PL", "pt-BR"],
  languages: {
    "en-GB": "English (UK)",
    "en-US": "English (US)",
    "it-IT": "Italiano",
    "fr-FR": "Français",
    "nl-NL": "Nederlands",
    "pl-PL": "Polski",
    "pt-BR": "Português (BR)",
  },
};

export const brand = {
  footer: {
    url: "https://ark.io",
    text: "ARK.io",
  },
};

export const knownWalletsUrls = {
  mainnet: "https://raw.githubusercontent.com/ArkEcosystem/common/master/mainnet/known-wallets.json",
  devnet: "https://raw.githubusercontent.com/ArkEcosystem/common/master/devnet/known-wallets.json",
};

export const socialMedia = [
  {
    name: "facebook",
    url: "https://facebook.ark.io",
    viewBox: "0 0 10 16",
  },
  {
    name: "twitter",
    url: "https://twitter.ark.io",
    viewBox: "0 0 16 16",
  },
  {
    name: "youtube",
    url: "https://youtube.ark.io",
    viewBox: "0 0 18 16",
  },
  {
    name: "email",
    url: "mailto:info@ark.io",
    viewBox: "0 0 16 16",
  },
  {
    name: "telegram",
    url: "https://telegram.me/ArkEcosystem",
    viewBox: "0 0 14 16",
  },
  {
    name: "reddit",
    url: "https://reddit.ark.io",
    viewBox: "0 0 16 16",
  },
  {
    name: "github",
    url: "https://github.ark.io",
    viewBox: "0 0 16 16",
  },
  {
    name: "bitcointalk",
    url: "https://bitcointalk.ark.io",
    viewBox: "0 0 16 16",
  },
  {
    name: "slack",
    url: "https://slack.ark.io",
    viewBox: "0 0 14 16",
  },
  {
    name: "discord",
    url: "https://discord.ark.io",
    viewBox: "0 0 14 16",
  },
  {
    name: "instagram",
    url: "https://instagram.ark.io",
    viewBox: "0 0 14 16",
  },
  {
    name: "medium",
    url: "https://blog.ark.io",
    viewBox: "0 0 16 16",
  },
  {
    name: "soundcloud",
    url: "https://soundcloud.com/thearkcryptopodcast",
    viewBox: "0 0 20 16",
  },
  {
    name: "minds",
    url: "https://www.minds.com/arkecosystem",
    viewBox: "0 0 14 16",
  },
];
